import { Text } from '@epam/promo';
import parse from 'html-react-parser';
import { HighlightedTextProps } from './HighlightedText.model';

export const HighlightedText = ({
  text = '',
  highlights = [],
}: HighlightedTextProps) => {
  if (!highlights.length) {
    return (
      <Text color="gray80" fontSize="16" lineHeight="24">
        {text}
      </Text>
    );
  }

  let popupText = text;

  highlights.forEach((item) => {
    popupText = popupText.replace(item, `<b>${item}</b>`);
  });

  return (
    <Text color="gray80" fontSize="16" lineHeight="24">
      {parse(popupText)}
    </Text>
  );
};
